import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { H3, H4 } from '../../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../../styles/FontStyles';

import { color } from '../../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioOrders,
  IconPortfolioPoolTicket
} from '../../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from '../Portfolio.styled';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../../app/hooks';
import { formatUSD, USDT } from '../../../helpers/helperFunctions';
import { getMyHubsSubscriptionsBundle } from '../Portfolio.actions';

import { TRAVEL_PACKAGES } from '../../../routes/routes';

import Spinner from '../../../components/common/Spinner';
import { SubscriptionBundleItem } from './SubscriptionBundleItem';
import { SidebarModal } from '../../../components/common/Sidebar/Sidebar';

import { AnimatePresence } from 'framer-motion';
import { SendGiftSteps } from './Subscription.types';
import { AnimatedTab } from '../../../components';
import { SendGift } from './SendGift';
import { Success } from './Success';

export const SubscriptionsBundleSummary = () => {
  const dispatch = useDispatch();

  const ref = useRef<any>(null);
  const [expanded, setExpanded] = useState(true);
  const history = useHistory();
  const [height, setHeight] = useState(ref?.current?.clientHeight);
  const { travelPackages, subscriptionsBundle, loadingSummary, giftLoading } =
    useAppSelector((state) => state.portfolio);

  const [step, setStep] = useState<SendGiftSteps>(SendGiftSteps.PAYMENT_METHOD);
  const [openGiftModal, setOpenGiftModal] = useState<boolean>(false);
  const [giftOrder, setGiftOrder] = useState();

  const handleSidebarTitle = (step: SendGiftSteps) => {
    switch (step) {
      case SendGiftSteps.PAYMENT_METHOD:
        return 'Give a Yearly Subscription';
      case SendGiftSteps.SUCCESS:
        return 'Yearly Subscription Sent';

      default:
        return '';
    }
  };

  const renderTitle = handleSidebarTitle(step);

  useEffect(() => {
    dispatch(getMyHubsSubscriptionsBundle());
  }, [dispatch]);

  return (
    <div style={{ marginBottom: 40 }}>
      <Flexed mb='20' center between>
        <H3>My Travelution Summary</H3>
      </Flexed>

      <SummaryGrid columns>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Total Travelution Orders
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(travelPackages?.summary?.totalOrderAmount)}
              <P3 mb='1'>{USDT}</P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <SummaryGrid columns>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioPoolTicket />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Silver pool ticket
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {travelPackages?.summary?.silverPoolTickets}
              <P3 mb='1'>
                {travelPackages?.summary?.silverPoolTickets === '1'
                  ? 'Ticket'
                  : 'Tickets'}
              </P3>
            </P1>
          </div>
        </BoxPortfolio>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioPoolTicket />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Gold Pool Ticket
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {travelPackages?.summary?.goldPoolTickets}
              <P3 mb='1'>
                {travelPackages?.summary?.goldPoolTickets === '1'
                  ? 'Ticket'
                  : 'Tickets'}
              </P3>
            </P1>
          </div>
        </BoxPortfolio>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioPoolTicket />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Platinum pool ticket
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {travelPackages?.summary?.platinumPoolTickets}
              <P3 mb='1'>
                {travelPackages?.summary?.platinumPoolTickets === '1'
                  ? 'Ticket'
                  : 'Tickets'}{' '}
              </P3>
            </P1>
          </div>
        </BoxPortfolio>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioPoolTicket />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Ultra-VIP pool ticket
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {travelPackages?.summary?.ultraVipPoolTickets}
              <P3 mb='1'>
                {' '}
                {travelPackages?.summary?.ultraVipPoolTickets === '1'
                  ? 'Ticket'
                  : 'Tickets'}{' '}
              </P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <div style={{ position: 'relative' }}>
        {loadingSummary && <Spinner absolute transparent />}
      </div>

      <Flexed center between wrap>
        <Flexed
          mb='20'
          center
          gap='20px'
          pointer
          onClick={() => setExpanded(!expanded)}>
          <H4>My Travelution Bundle Subscriptions</H4>
          <ArrowChevron direction={expanded ? 'up' : 'down'} />
        </Flexed>

        <Button
          negative
          maxWidth='350px'
          maxWidthSM='100%'
          onClick={() => history.push(TRAVEL_PACKAGES)}>
          ADD TRAVELUTION BUNDLE SUBSCRIPTION
        </Button>
      </Flexed>

      <Collapsable expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {subscriptionsBundle?.map((item: any, i: number) => (
            <SubscriptionBundleItem
              key={i}
              item={item}
              setOpenGiftModal={setOpenGiftModal}
              openGiftModal={openGiftModal}
              setGiftOrder={setGiftOrder}
              setStep={setStep}
            />
          ))}
        </div>
      </Collapsable>

      <SidebarModal
        isOpen={openGiftModal}
        sidebarWidth={'600px'}
        setOpen={(v) => {
          setOpenGiftModal(v);
        }}
        title={renderTitle}>
        <AnimatePresence exitBeforeEnter>
          {giftLoading && <Spinner absolute transparent />}
          {step === SendGiftSteps.PAYMENT_METHOD && (
            <AnimatedTab key={SendGiftSteps.PAYMENT_METHOD}>
              <SendGift giftOrder={giftOrder} setStep={setStep} />
            </AnimatedTab>
          )}

          {step === SendGiftSteps.SUCCESS && (
            <AnimatedTab key={SendGiftSteps.SUCCESS}>
              <Success />
            </AnimatedTab>
          )}
        </AnimatePresence>
      </SidebarModal>
    </div>
  );
};
